import { useEffect, useRef } from 'react'
import { ETimelinePostStatus } from 'types'

export function SharedItemStatusChanger({
  status,
  onUpdateStatus,
}: {
  status: ETimelinePostStatus
  onUpdateStatus: (status: ETimelinePostStatus, isSilent: boolean) => void
}) {
  const isUpdated = useRef(false)

  useEffect(() => {
    if (status === ETimelinePostStatus.new && !isUpdated.current) {
      isUpdated.current = true
      onUpdateStatus(ETimelinePostStatus.review, true)
    }
  }, [status, onUpdateStatus])

  return null
}
